// Utility Data
import { NUMBERS, SYMBOLS } from "../GeneralData";

const LoginHelper = {
    verifyEmail(email) {
        if (email) {
            return email.includes('@') && email.includes('.') && email.length > 6 && email.length < 45;
        }
        return false;
    },


};

export default LoginHelper;